import React from 'react'

import { Label } from '../label'
import InputError from './InputError'

type Props = {
  /** Label to show on the input. */
  label?: string
  /** HTML for atribute */
  htmlFor: string
  /** Form field description. */
  description?: string
  /**
   * An error message to show below the input. This will replace the description if
   * it is present.
   */
  errorMessage?: string
  /** True if the input field is required */
  isRequired?: boolean
  /** Externally defined className */
  className?: string
  /**
   * Externally defined className for the label
   */
  labelClassName?: string
  /** Child elements. */
  children: React.ReactNode
}

/**  Renders a form input component for showing labels and descriptions around inputs. */
const FormInput = ({
  htmlFor,
  label,
  description,
  errorMessage,
  children,
  isRequired,
  className,
  labelClassName,
}: Props) => {
  const renderDescriptionOrError = () => {
    if (!!errorMessage) {
      return <InputError message={errorMessage} />
    } else if (!!description) {
      return (
        <p className="mt-1.5 text-sm text-foreground-subtle">{description}</p>
      )
    } else {
      return null
    }
  }

  return (
    <div className={className}>
      {!!label && (
        <Label htmlFor={htmlFor} className={labelClassName}>
          {label}
          {isRequired && <span className="text-red-500">{` *`}</span>}
        </Label>
      )}
      {children}
      {renderDescriptionOrError()}
    </div>
  )
}

FormInput.defaultProps = {
  isRequired: false,
}

export default FormInput
